export class Account {
    isAdmin: boolean;
    canBuy: boolean;
    uid?: string;
    name?: string;
}
